module.exports = __webpack_public_path__ + "img/4.362970a8.png";